import React from 'react';

import { Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import { useProjectActivitiesContext } from './PositionActivitiesContext';

export const validateAllocationPercentage = (value) => {
    if (value === null || value === '' || value === undefined) {
        return true;
    }

    const numberValue = Number(value);
    return !isNaN(numberValue) && numberValue >= 0 && numberValue <= 100;
};

const AllocationsSchema = Yup.lazy((obj) =>
    Yup.object(
        Object.keys(obj).reduce((schema, monthKey) => {
            const formattedMonth = moment(monthKey, 'MM-YYYY').format('MMMM YYYY');
            const errorMessage = $t('Total allocation for {{month}} has exceeded 100%', { month: formattedMonth });
            schema[monthKey] = Yup.object()
                .nullable()
                .test(
                    'all-percentages-numbers',
                    $t('All allocations must be valid percentage number from 0 to 100 for {{month}}', { month: formattedMonth }),
                    (monthAllocations) => {
                        if (!monthAllocations) {
                            return true;
                        }

                        return Object.values(monthAllocations).every((val) => validateAllocationPercentage(val));
                    },
                )
                .test('sum-not-exceeding-100', errorMessage, (monthAllocations) => {
                    if (!monthAllocations) {
                        return true;
                    }

                    const sum = Object.values(monthAllocations).reduce((acc, val) => acc + (Number(val) || 0), 0);
                    return sum <= 100;
                })
                .test('sum-not-negative', $t('Total allocation for {{month}} cannot be negative', { month: formattedMonth }), (monthAllocations) => {
                    if (!monthAllocations) {
                        return true;
                    }

                    const sum = Object.values(monthAllocations).reduce((acc, val) => acc + (Number(val) || 0), 0);
                    return sum >= 0;
                });
            return schema;
        }, {}),
    ),
);

export const AllocationFormProvider = ({ initialAllocations, children }) => {
    const { updateAllocations, setIsResourceAllocationMode, allocations, activitiesCosts } = useProjectActivitiesContext();

    return (
        <Formik
            enableReinitialize
            initialValues={initialAllocations || {}}
            validationSchema={AllocationsSchema}
            onSubmit={(values, actions) => {
                updateAllocations(values)
                    .then(() => {
                        setIsResourceAllocationMode(false);
                        actions.resetForm(); //! important to reset the form to ensure initialValues are updated
                        allocations.refetch();
                        activitiesCosts.refetch();
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {children}
        </Formik>
    );
};
